import firebase from "firebase";

firebase.initializeApp({
  messagingSenderId: "191055722278",
  appId: "1:191055722278:web:0a98267a2939b1d2",
});

export default firebase;
